import styles from './heading.module.css';

export function MediaUserLoginGuideHeading({...props}) {
  return (
    <p className={styles.heading} {...props}>
      <span>このプレスリリースには、</span>
      <span>メディア関係者向けの情報があります</span>
    </p>
  );
}
